import { NgModule, Component, Input, ChangeDetectionStrategy, ViewChild, ChangeDetectorRef, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer, Location } from '@angular/common'
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';
import { DEVICE_INFO, APP_SETTINGS, DeviceInfo, CarouselRowConfig } from 'angular-engine/modules/ng-express-engine/tokens';

@Component({
    selector: 'series-spotlight',
    templateUrl: 'series-spotlight.template.html',
    styleUrls: ['series-spotlight.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SeriesSpotlight {
    @Input() item: any;
    public isPhone: boolean;
    /**
     * SeriesSpotlight component
     */
    constructor(private coreEffects: CoreEffects, 
        private cd: ChangeDetectorRef, 
        @Inject(DEVICE_INFO) private deviceInfo: DeviceInfo) {
            this.isPhone = deviceInfo.isPhone;
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/series/series-spotlight/series-spotlight.component.ts